<template>
    <v-container class="fill-height" style="display: block;" fluid>

        <v-window v-model="windowPage" style="width: 100%;" touchless>
        
            <v-window-item :key="0">
                <div id="ag-grid-container">
                    <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                        :gridOptions="gridOptions"
                        :groupHeaders="true"
                        :rowHeight="40">
                    </ag-grid-vue>
                </div>
            </v-window-item>

            <v-window-item :key="1">
                <div v-if="showResults">
                    <report-results :selectedReport="reportResults.selectedReport" :reportDetails="''" :reportData="reportResults.results" 
                        :runReportParams="''" :runReportHumanText="reportResults.human_params" @back="backToReportHistory">
                    </report-results>
                </div>
            </v-window-item>

        </v-window>
        
    </v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import ReportResults from '@/components/Reports/ReportResults';
export default {
    name: 'ReportHistory',
    props: [],
    components: {
        'ag-grid-vue': AgGridVue,
        ReportResults
    },
    data: () => ({
        windowPage: 0,
        showGrid: false,
        gridOptions: {},
        gridApi: null,
        reportHistoryList: [],

        showResults: false,
        reportResults: null
    }),

    computed: {
        backgroundReportShortcut: function() {
            return this.$store.state.backgroundReportShortcut;
        },
    },

    methods: {
        getReportHistory: function() {
            let route = (TELSA.apiHost + "report/history");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let results = response.body;
                this.reportHistoryList = results;
                for(let report of this.reportHistoryList) {
                    report.hasPermissions = TELSA.checkPermissionQualifier(this.$store.state.user, `reports/run`, report.report_name, !this.$store.state.batchConfig.product_perms);
                }
                this.buildAgGrid();
                TELSA.loading(false);
            });
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.reportHistoryList;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridApi = self.gridOptions.api;
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'reportHistory');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: 'Report', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'report_name'
                },
                { 
                    headerName: 'User', 
                    width: 100, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'user_username'
                },
                { 
                    headerName: 'Run Time', 
                    width: 150, filter: 'date', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return TELSA.moment(params.data.start_time).format('YYYY-MM-DD HH:mm:ss');
                    }
                },
                { 
                    headerName: 'Params', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'human_params'
                },
                { 
                    headerName: 'Completed Time', 
                    width: 150, filter: 'date', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return TELSA.moment(params.data.completed_time).format('YYYY-MM-DD HH:mm:ss');
                    }
                },
                { 
                    headerName: 'Duration', 
                    width: 100, filter: 'number', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.run_time_sec;
                    }
                },
                {
                    headerName: 'Results',
                    suppressSizeToFit: true,
                    width: 90, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'center', 'background-color': 'white', 'border-left': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            if(params.data.file_icon) {
                                this.eGui.innerHTML = `<span class="mdi mdi-file report-history-action" style="cursor: ${!params.data.hasPermissions ? 'default' : 'pointer'}; color: ${!params.data.hasPermissions ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`
                            }
                            else {
                                this.eGui.innerHTML = `<span class="mdi mdi-table report-history-action" style="cursor: ${!params.data.hasPermissions ? 'default' : 'pointer'}; color: ${!params.data.hasPermissions ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            }
                            this.btnClickedHandler = this.btnClickedHandler.bind(this);
                            this.resultsButton = this.eGui.querySelectorAll('.report-history-action')[0];
                            this.resultsButton.addEventListener('click', this.btnClickedHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        btnClickedHandler(event) {
                            event.stopPropagation();
                            if(!this.params.data.hasPermissions) {
                                this.params.showInsufficientPermissions(`You do not have permission to view this report.`);
                            }
                            else if(this.params.data.file_icon) {
                                this.params.downloadReportFile(this.params.data);
                            }
                            else {
                                this.params.showReportResults(this.params.data);
                            }
                        }
                        destroy() {
                            this.resultsButton.removeEventListener('click', this.btnClickedHandler);
                        }
                    },
                    cellRendererParams: {
                        showInsufficientPermissions: this.showInsufficientPermissions,
                        downloadReportFile: this.downloadReportFile,
                        showReportResults: this.showReportResults
                    }
                },
                {
                    headerName: 'Add/Remove', 
                    suppressSizeToFit: true,
                    width: 120, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'center', 'background-color': 'white', 'border-left': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.hasPermissions = TELSA.checkPermission(self.$store.state.user, `reports/incognito`);
                            this.eGui.innerHTML = `<span class="mdi ${!params.data.incognito ? 'mdi-delete-forever' : 'mdi-undo-variant'} remove-report-history-action" style="cursor: ${!this.hasPermissions ? 'default' : 'pointer'}; color: ${!this.hasPermissions ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            this.btnClickedHandler = this.btnClickedHandler.bind(this);
                            this.removeButton = this.eGui.querySelectorAll('.remove-report-history-action')[0];
                            this.removeButton.addEventListener('click', this.btnClickedHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        btnClickedHandler(event) {
                            event.stopPropagation();

                            if(this.hasPermissions) {
                                this.params.removeFromReportHistoryClick(this.params.data, !this.params.data.incognito);
                            }
                            else {
                                this.params.showInsufficientPermissions(`You do not have permission to ${this.params.data.incognito ? 'modify' : 'remove'} reports from report history.`);
                            }
                        }
                        destroy() {
                            this.removeButton.removeEventListener('click', this.btnClickedHandler);
                        }
                    },
                    cellRendererParams: {
                        removeFromReportHistoryClick: this.removeFromReportHistoryClick,
                        showInsufficientPermissions: this.showInsufficientPermissions
                    }
                },
            ];
            return columnDefs;
        },

        showInsufficientPermissions: function(message) {
            this.$store.commit('insufficientPermissions', {message: message});
        },

        showReportResults: function(reportResults) {
            let route = (TELSA.apiHost + "report/history/result");
            TELSA.loading(true);
            return this.$http.post(route, {args: {report_name: reportResults.report_name, params_hash: reportResults.params_hash}}).then(response => {
                let result = response.body;
                reportResults.results = result;
                this.reportResults = reportResults;
                this.reportResults.selectedReport = {
                    user_obj_name: reportResults.report_name,
                    history: true,
                    startTime: reportResults.start_time
                };
                TELSA.loading(false);
                this.$store.commit('setAiAnalyzerGridAPI', null);
                this.windowPage = 1;
                this.showResults = true;
            });
        },

        downloadReportFile: function(reportResults) {
            let route = (TELSA.apiHost + "report/history/result");
            TELSA.loading(true);
            return this.$http.post(route, {args: {report_name: reportResults.report_name, params_hash: reportResults.params_hash}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
                if(result.file_name) {
                    let dlink = document.createElement('a');
                    dlink.setAttribute("id", "report-download-file-link-hidden");
                    let url = new URL(`${TELSA.staticHost}${result.file_name}?prettyname=${result.pretty_name}`);
                    dlink.href = url;
                    dlink.click();
                    dlink.remove();
                }
            });
        },

        backToReportHistory: function() {
            this.windowPage = 0;
            this.showResults = false;
            this.reportResults = null;
            this.$store.commit('setAiAnalyzerGridAPI', null);
        },

        viewBackgroundReportResults: function() {
            this.showResults = false;
            this.$nextTick(function() {
                this.reportResults = this.$store.state.backgroundReportShortcut;
                this.reportResults.selectedReport = {
                    user_obj_name: this.reportResults.reportParamObj.report,
                    history: true,
                    startTime: TELSA.moment(this.reportResults.timeId).format('YYYY-MM-DD HH:mm:ss')
                };
                this.reportResults.human_params = this.reportResults.reportParamObj.humanParams.join(' ');
                TELSA.loading(false);
                this.windowPage = 1;
                this.showResults = true;
                this.$store.commit('clearBackgroundReportShortcut');
            });
        },

        removeFromReportHistoryClick: function(reportResults, remove) {
            this.$store.commit('showConfirmModal', {
                title: `${remove ? 'Remove From' : 'Add To'} History`,
                message: remove ? `Are you sure you want to remove this report from Report History?` : `Are you sure you want to add this report to Report History?`,
                type: 'warning',
                hideCancel: false,
                confirmAction: () => this.removeFromReportHistory(reportResults, remove)
            });
        },

        removeFromReportHistory: function(reportResults, remove) {
            let route = (TELSA.apiHost + "report/history/remove");
            TELSA.loading(true);
            return this.$http.post(route, {args: {report_name: reportResults.report_name, params_hash: reportResults.params_hash, hide: remove}}).then(response => {
                let result = response.body;
                //this.reportHistoryList.splice(this.reportHistoryList.indexOf(reportResults), 1);
                reportResults.incognito = remove;
                let filters = this.gridOptions.api.getFilterModel();
                this.gridOptions.api.setRowData(this.reportHistoryList);
                this.gridOptions.api.setFilterModel(filters);
                TELSA.loading(false);
            });
        }

    },

    watch: {
        windowPage: {
            handler(newVal, oldVal) {
                if(newVal == 0 && this.reportHistoryList.length == 0) {
                    this.getReportHistory();
                }
            },
            deep: true
        },

        backgroundReportShortcut: {
            handler(newVal, oldVal) {
                if(newVal) {
                    this.viewBackgroundReportResults();
                }
            },
        },
    },

    mounted() {
        if(this.$store.state.backgroundReportShortcut) {
            this.viewBackgroundReportResults();
        }
        else {
            this.getReportHistory();
        }
    },

    beforeDestroy() {
        this.gridApi.destroy();
    }

  
};
</script>

<style scoped>

    #ag-grid-container {
        height: calc(100vh - 80px);
    }

</style>
